function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoCentos(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "uc-social"
  }, props), React.createElement("path", {
    d: "M23.218 28.793l-6.629 5.945v9.432l21.69-.424zM52.099 38.661L68.19 23.323l-6.081-6.42h-10.01z"
  }), React.createElement("path", {
    d: "M46.166 40.366s.594 2.735 3.091 0c.238-2.378 0-25.92 0-25.92h8.68L47.434 4.458l-9.948 9.75h8.561l.119 26.158z"
  }), React.createElement("path", {
    d: "M44.541 38.463V16.705h-10.01l-6.081 6.42z"
  }), React.createElement("path", {
    d: "M23.218 24.869l18.786 18.548s2.854 1.348 2.259-1.415c-2.537-2.707-18.429-18.785-18.429-18.785l5.35-6.315H16.589l.447 14.03 6.182-6.063zM52.377 42.201c-.594 2.762 2.259 1.415 2.259 1.415l18.786-18.548 6.183 6.064.447-14.03H65.456l5.35 6.315c0-.001-15.893 16.077-18.429 18.784z"
  }), React.createElement("path", {
    d: "M58.361 43.944l21.691.424v-9.432l-6.63-5.945zM49.84 55.183s-.594-2.735-3.091 0c-.238 2.378 0 25.92 0 25.92h-8.68l10.503 9.987 9.948-9.75h-8.561l-.119-26.157z"
  }), React.createElement("path", {
    d: "M51.465 57.086v21.758h10.01l6.081-6.42z"
  }), React.createElement("path", {
    d: "M72.788 70.68L54.002 52.132s-2.854-1.348-2.259 1.415c2.536 2.707 18.429 18.785 18.429 18.785l-5.35 6.315h14.596l-.447-14.03-6.183 6.063z"
  }), React.createElement("path", {
    d: "M72.788 66.756l6.629-5.945v-9.432l-21.69.424zM43.907 56.888L27.816 72.226l6.081 6.42h10.01z"
  }), React.createElement("path", {
    d: "M43.629 53.348c.594-2.762-2.259-1.415-2.259-1.415L22.584 70.482l-6.183-6.064-.447 14.03H30.55l-5.35-6.315s15.893-16.078 18.429-18.785z"
  }), React.createElement("path", {
    d: "M22.584 66.558l15.061-14.953-21.691-.424v9.432zM91.824 47.68l-9.75-9.948v8.561l-26.158.119s-2.735.594 0 3.091c2.378.238 25.92 0 25.92 0v8.68l9.988-10.503z"
  }), React.createElement("path", {
    d: "M40.052 46.411c-2.378-.238-25.92 0-25.92 0v-8.68L4.145 48.235l9.75 9.948v-8.561l26.158-.119c-.001 0 2.734-.595-.001-3.092z"
  }));
}

SvgLogoCentos.clsName = 'icon-uc-social__logo-centos';
SvgLogoCentos.remarkName = 'unknown';
export default SvgLogoCentos;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoCentos.js
// module id = 2230
// module chunks = 17 18